@if (!!audit) {
  <fa-icon [icon]="auditIcon" class="info-icon"></fa-icon>
  <div class="audit-title">{{audit?.title}}</div>
}
@if (!audit && !isError) {
  <div class="audit-title loading"><fa-icon [icon]="faSyncAlt" animation="spin"></fa-icon></div>
}
@if (!audit && isError) {
  <div class="audit-title">Unknown audit</div>
}
